import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import EventDetailsToolbar from 'src/components/event/details/EventDetailsToolbar';
import { searchLeads } from 'src/utils/helper';
import LeadsListResults from 'src/components/event/details/LeadListResults';
import { useLocation, useNavigate } from 'react-router';
import _ from 'lodash';
import FirebaseApp, { Collections } from 'src/config/firebase.config';

const EventDetails = () => {
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState('');
  const [sortDirectionDate, setSortDirectionDate] = useState('asc');
  const [sortDirectionTitle, setSortDirectionTitle] = useState('asc');
  const [sortDirectionEmail, setSortDirectionEmail] = useState('asc');
  const navigate = useNavigate();
  const FirebaseDB = FirebaseApp.firestore();
  const { state } = useLocation();
  const [fullList, setFullList] = useState([]);

  const onSort = (row) => {
    if (row === 'LeadName') {
      if (sortDirectionTitle === 'asc') {
        setSortDirectionTitle('desc');
        setLeads([..._.orderBy(leads, 'title', 'desc')]);
      } else {
        setSortDirectionTitle('asc');
        setLeads([..._.orderBy(leads, 'title', 'asc')]);
      }
      setSortDirectionDate('asc');
      setSortDirectionEmail('asc');
    } else if (row === 'LeadEmail') {
      if (sortDirectionEmail === 'asc') {
        setSortDirectionEmail('desc');
        setLeads([..._.orderBy(leads, 'email', 'desc')]);
      } else {
        setSortDirectionEmail('asc');
        setLeads([..._.orderBy(leads, 'email', 'asc')]);
      }
      setSortDirectionTitle('asc');
      setSortDirectionDate('asc');
    } else if (row === 'StartDate') {
      if (sortDirectionDate === 'asc') {
        setSortDirectionDate('desc');
        setLeads([..._.orderBy(leads, 'createdAt', 'desc')]);
      } else {
        setSortDirectionDate('asc');
        setLeads([..._.orderBy(leads, 'createdAt', 'asc')]);
      }
      setSortDirectionTitle('asc');
      setSortDirectionEmail('asc');
    }
  };

  const fetchLeads = () => {
    FirebaseDB
      .collection(Collections.Leads)
      .where('id', '==', state.id)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((element) => {
          const data = element.data();
          setFullList((arr) => [...arr, { firebaseId: element.id, ...data }]);
          setLeads((arr) => [...arr, { firebaseId: element.id, ...data }]);
        });
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  useEffect(() => {
    setLeads(searchLeads(fullList, search));
  }, [search]);

  return (
    <>
      <Helmet>
        <title>Leads | Lead Generation</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <EventDetailsToolbar onSearch={(text) => {
            setSearch(text);
          }}
          />
          <Box sx={{ pt: 3 }}>
            <LeadsListResults
              leads={leads}
              onItemClick={(item) => {
                navigate(`/app/editLead/${item.firebaseId}`, { replace: false, state: item });
              }}
              sortDirectionTitle={sortDirectionTitle}
              sortDirectionDate={sortDirectionDate}
              sortDirectionEmail={sortDirectionEmail}
              onSort={onSort}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default EventDetails;
